export enum ChannelSourceProperties {
  utm_source = 'utm_source',
  utm_medium = 'utm_medium',
  utm_campaign = 'utm_campaign',
  utm_term = 'utm_term',
  utm_content = 'utm_content',
  int_cmpgn = 'int_cmpgn',
  int_dept = 'int_dept',
  int_lctn = 'int_lctn',
  int_fmt = 'int_fmt',
  int_dscpn = 'int_dscpn'
}

export type ChannelSource = {
  [key in ChannelSourceProperties]?: string;
};
